import { useState } from "react";

const INIT_ORDERS = [
  {
    id: 1,
    patient_name: "Nikhil Gornod", patient_phone: "9876543210",
    ordered_by_name: "Dr. Priya Mehta",
    lab_title: "WellScan Diagnostic Services",
    order_date: "2026-04-01", order_time: "10:00",
    priority: "Routine",
    clinical_notes: "Fever — evaluate infection and anaemia",
    admission_no: "IPD20260001",
    notes: null,
    items: [
      { id:1, test_title:"Complete Blood Count (CBC)",            amount:250, status:"Completed",
        result_text:"WBC: 11.2 K/µL (High)\nRBC: 4.5 M/µL (Normal)\nHaemoglobin: 13.2 g/dL (Normal)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30" },
      { id:2, test_title:"Erythrocyte Sedimentation Rate (ESR)", amount:150, status:"Completed",
        result_text:"ESR: 45 mm/hr (High)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30" },
      { id:3, test_title:"Liver Function Test (LFT)",            amount:400, status:"Completed",
        result_text:"ALT: 38 U/L (Normal)\nAST: 42 U/L (Normal)",
        result_date:"2026-04-01", sample_collected_at:"2026-04-01 10:30" },
    ]
  },
  {
    id: 2,
    patient_name: "Ritu Sharma", patient_phone: "9876501234",
    ordered_by_name: "Dr. Ravi Kumar",
    lab_title: "WellScan Diagnostic Services",
    order_date: "2026-04-03", order_time: "09:00",
    priority: "Urgent",
    clinical_notes: "Day 3 follow-up bloods",
    admission_no: "IPD20260002",
    notes: "Repeat CBC + RFT",
    items: [
      { id:4, test_title:"Complete Blood Count (CBC)", amount:250, status:"Processing",
        result_text:null, result_date:null, sample_collected_at:"2026-04-03 09:30" },
      { id:5, test_title:"Renal Function Test (RFT)",  amount:350, status:"Sample Collected",
        result_text:null, result_date:null, sample_collected_at:"2026-04-03 09:30" },
    ]
  },
  {
    id: 3,
    patient_name: "Arjun Patel", patient_phone: "9812345678",
    ordered_by_name: "Dr. Priya Mehta",
    lab_title: "AccuTest Path Labs",
    order_date: "2026-04-04", order_time: "08:30",
    priority: "STAT",
    clinical_notes: "Pre-operative workup — surgery at 9am",
    admission_no: "IPD20260003",
    notes: null,
    items: [
      { id:6, test_title:"Complete Blood Count (CBC)", amount:250, status:"Completed",
        result_text:"WBC: 14.8 K/µL (High)\nHaemoglobin: 12.8 g/dL (Low)",
        result_date:"2026-04-04", sample_collected_at:"2026-04-04 08:45" },
      { id:7, test_title:"Blood Sugar Fasting (BSF)",  amount:80,  status:"Completed",
        result_text:"Fasting Blood Sugar: 94 mg/dL (Normal)",
        result_date:"2026-04-04", sample_collected_at:"2026-04-04 08:45" },
      { id:8, test_title:"Renal Function Test (RFT)",  amount:350, status:"Ordered",
        result_text:null, result_date:null, sample_collected_at:null },
    ]
  },
  {
    id: 4,
    patient_name: "Meena Joshi", patient_phone: "9700012345",
    ordered_by_name: "Dr. Anjali Singh",
    lab_title: "LifeCheck Medical Laboratory",
    order_date: "2026-04-06", order_time: "11:00",
    priority: "Routine",
    clinical_notes: "Routine thyroid and sugar monitoring",
    admission_no: null,
    notes: null,
    items: [
      { id:9, test_title:"Thyroid Function Test (TFT)", amount:550, status:"Processing",
        result_text:null, result_date:null, sample_collected_at:"2026-04-06 11:30" },
      { id:10, test_title:"Blood Sugar Fasting (BSF)", amount:80, status:"Ordered",
        result_text:null, result_date:null, sample_collected_at:null },
    ]
  },
];

const INIT_LINKED_LABS = [
  { id:1, clinic_title:"MediCure Health Center",  lab_title:"WellScan Diagnostic Services",    lab_phone:"+91 98000 00021", lab_email:"info@wellscan.com",    is_default:1, active:1, notes:"Primary in-house lab" },
  { id:2, clinic_title:"MediCure Health Center",  lab_title:"AccuTest Path Labs",              lab_phone:"+91 98000 00023", lab_email:"info@accutest.com",    is_default:0, active:1, notes:"Specialised tests" },
  { id:3, clinic_title:"VitalCare Clinic",        lab_title:"WellScan Diagnostic Services",    lab_phone:"+91 98000 00021", lab_email:"info@wellscan.com",    is_default:1, active:1, notes:null },
  { id:4, clinic_title:"NovaMed Clinic",          lab_title:"AccuTest Path Labs",              lab_phone:"+91 98000 00023", lab_email:"info@accutest.com",    is_default:1, active:1, notes:null },
  { id:5, clinic_title:"Harmony Health Clinic",   lab_title:"LifeCheck Medical Laboratory",   lab_phone:"+91 98000 00024", lab_email:"info@lifechecl.com",   is_default:1, active:1, notes:null },
  { id:6, clinic_title:"CareWell Clinic",         lab_title:"PrimeCare Pathology Center",     lab_phone:"+91 98000 00026", lab_email:"info@primecare.com",   is_default:1, active:1, notes:null },
];

const PRIORITIES = ["All", "Routine", "Urgent", "STAT"];
const STATUSES   = ["All", "Ordered", "Sample Collected", "Processing", "Completed", "Cancelled"];
const STAT_OPTIONS = ["Ordered", "Sample Collected", "Processing", "Completed", "Cancelled"];
const PRIO_OPTIONS = ["Routine", "Urgent", "STAT"];

const LABS    = ["WellScan Diagnostic Services","AccuTest Path Labs","LifeCheck Medical Laboratory","PrimeCare Pathology Center"];
const CLINICS = ["MediCure Health Center","VitalCare Clinic","NovaMed Clinic","Harmony Health Clinic","CareWell Clinic"];

const LAB_INFO = {
  "WellScan Diagnostic Services":  { phone:"+91 98000 00021", email:"info@wellscan.com" },
  "AccuTest Path Labs":            { phone:"+91 98000 00023", email:"info@accutest.com" },
  "LifeCheck Medical Laboratory":  { phone:"+91 98000 00024", email:"info@lifechecl.com" },
  "PrimeCare Pathology Center":    { phone:"+91 98000 00026", email:"info@primecare.com" },
};

const LAB_TESTS = [
  { title:"Complete Blood Count (CBC)",            amount:250 },
  { title:"Erythrocyte Sedimentation Rate (ESR)", amount:150 },
  { title:"Liver Function Test (LFT)",             amount:400 },
  { title:"Renal Function Test (RFT)",             amount:350 },
  { title:"Blood Sugar Fasting (BSF)",             amount:80  },
  { title:"Thyroid Function Test (TFT)",           amount:550 },
  { title:"Lipid Profile",                         amount:600 },
  { title:"Urine Routine",                         amount:120 },
  { title:"HbA1c",                                 amount:450 },
  { title:"Serum Electrolytes",                    amount:300 },
];

const PRIORITY_STYLE = {
  "Routine": { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Urgent":  { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "STAT":    { bg:"rgba(239,68,68,.15)",   color:"#ef4444" },
};

const STATUS_STYLE = {
  "Ordered":          { bg:"rgba(107,114,128,.12)", color:"#9ca3af" },
  "Sample Collected": { bg:"rgba(59,130,246,.12)",  color:"#3b82f6" },
  "Processing":       { bg:"rgba(245,158,11,.12)",  color:"#f59e0b" },
  "Completed":        { bg:"rgba(16,185,129,.12)",  color:"#10b981" },
  "Cancelled":        { bg:"rgba(239,68,68,.12)",   color:"#ef4444" },
};

const ini  = n=>(n||"?").split(" ").map(x=>x[0]).join("").slice(0,2).toUpperCase();
const CLRS = ["#5E7BFF","#10B981","#F59E0B","#0891B2","#7C3AED","#EF4444"];
const pClr = n=>CLRS[(n||"").charCodeAt(0)%CLRS.length];

const css=`
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=IBM+Plex+Sans:wght@300;400;500;600&family=IBM+Plex+Mono:wght@400;500&display=swap');
*{box-sizing:border-box;margin:0;padding:0;}
:root{--bg:#0A0C12;--bg2:#111318;--bg3:#181B24;--bg4:#1E2130;--border:#252836;--border2:#2E3348;--text:#EDF0FF;--muted:#6B7A99;--dim:#3D4563;--accent:#5E7BFF;--accent2:#8B9FFF;--green:#10B981;--red:#EF4444;--amber:#F59E0B;--blue:#3B82F6;}
body{background:var(--bg);color:var(--text);font-family:'IBM Plex Sans',sans-serif;min-height:100vh;}
.page{max-width:1200px;margin:0 auto;padding:24px 20px;}
.page-tabs{display:flex;gap:0;background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:4px;margin-bottom:24px;width:fit-content;}
.ptab{padding:9px 20px;border-radius:8px;font-size:13px;font-weight:500;color:var(--muted);cursor:pointer;border:none;background:none;font-family:'IBM Plex Sans',sans-serif;transition:all .15s;}
.ptab.active{background:var(--accent);color:#fff;}
.ptab:hover:not(.active){background:var(--bg3);color:var(--text);}
.ph{display:flex;align-items:center;justify-content:space-between;margin-bottom:20px;}
.ph-title{font-family:'Playfair Display',serif;font-size:22px;font-weight:700;}
.ph-sub{font-size:12px;color:var(--muted);margin-top:2px;}
.sr{display:grid;gap:12px;margin-bottom:20px;}
.sc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px 18px;}
.sl{font-size:10px;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;margin-bottom:6px;}
.sv{font-family:'Playfair Display',serif;font-size:26px;font-weight:700;}
.sb{height:3px;border-radius:2px;margin-top:8px;}
.fb{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:12px 16px;display:flex;gap:10px;align-items:center;margin-bottom:14px;flex-wrap:wrap;}
.sw{position:relative;flex:1;min-width:180px;}
.si{position:absolute;left:10px;top:50%;transform:translateY(-50%);color:var(--muted);font-size:13px;pointer-events:none;}
.input{width:100%;padding:8px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);color:var(--text);font-size:12px;font-family:'IBM Plex Sans',sans-serif;outline:none;transition:border-color .15s;}
.input:focus{border-color:var(--accent);}
.sip{padding-left:32px;}
.sel{appearance:none;cursor:pointer;}
.tg{display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:12px;}
.tc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:16px;transition:border-color .15s;}
.tc:hover{border-color:var(--border2);}
.tc.off{opacity:.55;}
.tch{display:flex;align-items:flex-start;gap:10px;margin-bottom:10px;}
.tci{width:38px;height:38px;border-radius:10px;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;}
.tcn{font-size:13px;font-weight:600;line-height:1.4;}
.tcs{font-size:11px;color:var(--muted);margin-top:1px;}
.tcf{display:flex;align-items:center;gap:6px;margin-top:10px;padding-top:10px;border-top:1px solid var(--border);flex-wrap:wrap;}
.chip{display:inline-flex;align-items:center;padding:2px 8px;border-radius:6px;font-size:10px;font-weight:600;}
.price{font-family:'IBM Plex Mono',monospace;font-size:15px;font-weight:600;color:var(--accent2);margin-left:auto;}
.ib{width:26px;height:26px;border-radius:6px;border:1px solid var(--border2);background:transparent;color:var(--muted);cursor:pointer;display:inline-flex;align-items:center;justify-content:center;font-size:11px;transition:all .15s;}
.ib:hover{border-color:var(--accent2);color:var(--accent2);}
.ib.d:hover{border-color:#ef4444;color:#ef4444;}
.oc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;overflow:hidden;margin-bottom:10px;}
.oh{padding:12px 16px;display:flex;align-items:center;gap:10px;cursor:pointer;transition:background .1s;}
.oh:hover{background:var(--bg3);}
.av{width:34px;height:34px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:12px;font-weight:700;color:#fff;flex-shrink:0;}
.sp{display:inline-flex;align-items:center;gap:3px;padding:2px 8px;border-radius:10px;font-size:10px;font-weight:600;}
.rb{background:var(--bg3);border-radius:8px;padding:8px 10px;font-size:11px;color:var(--muted);line-height:1.5;margin-top:6px;white-space:pre-line;}
.btn{display:inline-flex;align-items:center;gap:6px;padding:8px 16px;border-radius:8px;font-size:12px;font-weight:500;cursor:pointer;border:none;font-family:'IBM Plex Sans',sans-serif;transition:all .15s;}
.bp{background:var(--accent);color:#fff;}
.bp:hover{background:#4a67e8;}
.bp:disabled{opacity:.5;cursor:not-allowed;}
.bg_{background:var(--bg3);color:var(--text);border:1px solid var(--border2);}
.bg_:hover{border-color:var(--accent2);}
.bsm{padding:4px 10px;font-size:11px;}
.empty{padding:40px;text-align:center;color:var(--muted);}
.mb{position:fixed;inset:0;background:rgba(0,0,0,.75);z-index:50;display:flex;align-items:center;justify-content:center;padding:20px;}
.mx{background:var(--bg2);border:1px solid var(--border2);border-radius:16px;padding:28px;width:100%;max-width:560px;max-height:90vh;overflow-y:auto;}
.mt{font-family:'Playfair Display',serif;font-size:17px;font-weight:700;margin-bottom:18px;display:flex;align-items:center;justify-content:space-between;}
.mg{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:14px;}
.mf{grid-column:1/-1;}
.field{display:flex;flex-direction:column;gap:5px;}
.field label{font-size:11px;font-weight:600;color:var(--muted);text-transform:uppercase;letter-spacing:.07em;}
.ta{resize:vertical;min-height:70px;}
.ma{display:flex;gap:8px;justify-content:flex-end;margin-top:16px;padding-top:14px;border-top:1px solid var(--border);}
.tw{display:flex;align-items:center;gap:10px;}
.tgl{width:40px;height:22px;border-radius:11px;background:var(--bg3);border:1px solid var(--border2);position:relative;cursor:pointer;transition:all .2s;}
.tgl.on{background:var(--accent);border-color:var(--accent);}
.tk{position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;top:2px;left:2px;transition:left .2s;}
.tgl.on .tk{left:20px;}
.err{font-size:11px;color:#ef4444;margin-top:3px;}
.toast{position:fixed;bottom:24px;right:24px;background:var(--bg3);border:1px solid var(--border2);border-radius:10px;padding:12px 18px;display:flex;align-items:center;gap:10px;font-size:13px;font-weight:500;z-index:100;animation:su .25s ease;}
@keyframes su{from{transform:translateY(16px);opacity:0}to{transform:translateY(0);opacity:1}}
.dw{background:rgba(239,68,68,.08);border:1px solid rgba(239,68,68,.2);border-radius:8px;padding:10px 14px;font-size:12px;color:#ef4444;margin-bottom:14px;}
.tsel{display:flex;align-items:center;justify-content:space-between;padding:7px 12px;border-radius:8px;border:1px solid var(--border2);background:var(--bg3);cursor:pointer;font-size:12px;transition:all .15s;}
.tsel.on{border-color:var(--accent);background:rgba(94,123,255,.1);}
.lc{background:var(--bg2);border:1px solid var(--border);border-radius:12px;padding:14px 16px;display:flex;align-items:flex-start;gap:12px;margin-bottom:10px;transition:border-color .15s;}
.lc:hover{border-color:var(--border2);}
.lc.off{opacity:.55;}
`;

function Modal({title,onClose,children}){return(<div className="mb" onClick={onClose}><div className="mx" onClick={e=>e.stopPropagation()}><div className="mt">{title}<button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",fontSize:18}}>✕</button></div>{children}</div></div>);}

function DelModal({onClose,onConfirm,title,msg}){
  return(<Modal title="Confirm Delete" onClose={onClose}><div className="dw">⚠ {msg}</div><div style={{fontSize:13,color:"var(--muted)",marginBottom:14}}>{title}</div><div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn" style={{background:"rgba(239,68,68,.15)",color:"#ef4444",border:"1px solid rgba(239,68,68,.3)"}} onClick={onConfirm}>Yes, Delete</button></div></Modal>);
}

function OrderModal({onClose,onSave}){
  const [f,setF]=useState({patient_name:"",patient_phone:"",lab_title:LABS[0],priority:"Routine",order_date:"2026-04-06",order_time:"10:00",clinical_notes:"",admission_no:""});
  const [sel,setSel]=useState([]);
  const [errs,setErrs]=useState({});
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>{setF(p=>({...p,[k]:v}));setErrs(p=>({...p,[k]:""}));};
  const toggle=t=>setSel(s=>s.find(x=>x.title===t.title)?s.filter(x=>x.title!==t.title):[...s,t]);
  const total=sel.reduce((s,t)=>s+t.amount,0);
  const save=()=>{
    const e={};
    if(!f.patient_name.trim())e.patient_name="Required";
    if(!sel.length)e.tests="Select at least one test";
    if(Object.keys(e).length){setErrs(e);return;}
    setSaving(true);
    setTimeout(()=>onSave({...f,admission_no:f.admission_no.trim()||null,items:sel.map((t,i)=>({id:Date.now()+i,test_title:t.title,amount:t.amount,status:"Ordered",result_text:null,result_date:null,sample_collected_at:null}))}),500);
  };
  return(
    <Modal title="Add Lab Order" onClose={onClose}>
      <div className="mg">
        <div className="field"><label>Patient Name *</label><input className="input" value={f.patient_name} onChange={e=>set("patient_name",e.target.value)} placeholder="Search patient…"/>{errs.patient_name&&<span className="err">{errs.patient_name}</span>}</div>
        <div className="field"><label>Patient Phone</label><input className="input" value={f.patient_phone} onChange={e=>set("patient_phone",e.target.value)} placeholder="98xxxxxxxx"/></div>
        <div className="field"><label>Lab *</label><select className="input sel" value={f.lab_title} onChange={e=>set("lab_title",e.target.value)}>{LABS.map(l=><option key={l}>{l}</option>)}</select></div>
        <div className="field"><label>Admission No</label><input className="input" value={f.admission_no} onChange={e=>set("admission_no",e.target.value)} placeholder="IPD… (optional)"/></div>
        <div className="field mf"><label>Priority *</label>
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
            {PRIO_OPTIONS.map(p=>{const ps=PRIORITY_STYLE[p]||{};return(<button key={p} onClick={()=>set("priority",p)} style={{padding:"9px",borderRadius:8,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",fontSize:12,fontWeight:600,transition:"all .15s",background:f.priority===p?ps.color:ps.bg,color:f.priority===p?"#fff":ps.color,border:`1px solid ${ps.color}55`}}>{f.priority===p?"✓ ":""}{p}</button>);})}
          </div>
        </div>
        <div className="field"><label>Order Date</label><input className="input" type="date" value={f.order_date} onChange={e=>set("order_date",e.target.value)}/></div>
        <div className="field"><label>Order Time</label><input className="input" type="time" value={f.order_time} onChange={e=>set("order_time",e.target.value)}/></div>
        <div className="field mf"><label>Clinical Notes</label><textarea className="input ta" value={f.clinical_notes} onChange={e=>set("clinical_notes",e.target.value)} placeholder="Reason / indication…" style={{minHeight:56}}/></div>
        <div className="field mf"><label>Tests *</label>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:6}}>
            {LAB_TESTS.map(t=>{const on=sel.find(x=>x.title===t.title);return(<div key={t.title} className={`tsel${on?" on":""}`} onClick={()=>toggle(t)}><span>{on?"✓ ":""}{t.title}</span><span style={{fontFamily:"'IBM Plex Mono',monospace",color:"var(--accent2)",fontSize:11}}>₹{t.amount}</span></div>);})}
          </div>
          {errs.tests&&<span className="err">{errs.tests}</span>}
          {sel.length>0&&<div style={{fontSize:11,color:"var(--muted)",marginTop:6}}>{sel.length} test{sel.length!==1?"s":""} · <span style={{color:"var(--accent2)",fontFamily:"'IBM Plex Mono',monospace"}}>₹{total.toLocaleString()}</span></div>}
        </div>
      </div>
      <div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn bp" onClick={save} disabled={saving}>{saving?"Saving…":"Add Order"}</button></div>
    </Modal>
  );
}

function StatusModal({onClose,item,onSave}){
  const [status,setStatus]=useState(item?.status||"Ordered");
  const [sc,setSc]=useState(item?.sample_collected_at||"");
  const [saving,setSaving]=useState(false);
  const save=()=>{setSaving(true);setTimeout(()=>onSave({status,sample_collected_at:sc||null}),400);};
  return(
    <Modal title={`Update Status — ${item?.test_title}`} onClose={onClose}>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:14}}>
        {STAT_OPTIONS.map(s=>{const ss=STATUS_STYLE[s]||{};return(<button key={s} onClick={()=>setStatus(s)} style={{padding:"9px",borderRadius:8,cursor:"pointer",fontFamily:"'IBM Plex Sans',sans-serif",fontSize:12,fontWeight:600,transition:"all .15s",background:status===s?ss.color:ss.bg,color:status===s?"#fff":ss.color,border:`1px solid ${ss.color}55`}}>{status===s?"✓ ":""}{s}</button>);})}
      </div>
      {status==="Sample Collected"&&<div className="field" style={{marginBottom:14}}><label>Sample Collected At</label><input className="input" value={sc} onChange={e=>setSc(e.target.value)} placeholder="2026-04-06 10:30"/></div>}
      <div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn bp" onClick={save} disabled={saving}>{saving?"Updating…":"Update Status"}</button></div>
    </Modal>
  );
}

function ResultModal({onClose,item,onSave}){
  const [f,setF]=useState({result_text:"",result_date:"2026-04-06"});
  const [err,setErr]=useState("");
  const [saving,setSaving]=useState(false);
  const save=()=>{if(!f.result_text.trim()){setErr("Result required");return;}setSaving(true);setTimeout(()=>onSave(f),500);};
  return(
    <Modal title={`Add Result — ${item?.test_title}`} onClose={onClose}>
      <div style={{background:"rgba(16,185,129,.08)",border:"1px solid rgba(16,185,129,.2)",borderRadius:8,padding:"10px 12px",fontSize:12,marginBottom:14}}>
        <span style={{color:"#10b981",fontWeight:600}}>{item?.test_title}</span>
        <span style={{color:"var(--muted)",marginLeft:8}}>₹{item?.amount?.toLocaleString()}</span>
        {item?.sample_collected_at&&<div style={{color:"var(--muted)",marginTop:3}}>🧫 Sample: {item.sample_collected_at}</div>}
      </div>
      <div className="mg">
        <div className="field mf"><label>Result *</label><textarea className="input ta" value={f.result_text} onChange={e=>{setF(p=>({...p,result_text:e.target.value}));setErr("");}} placeholder="Enter test result values…" style={{minHeight:120}}/>{err&&<span className="err">{err}</span>}</div>
        <div className="field"><label>Result Date</label><input className="input" type="date" value={f.result_date} onChange={e=>setF(p=>({...p,result_date:e.target.value}))}/></div>
      </div>
      <div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn bp" onClick={save} disabled={saving}>{saving?"Saving…":"Save Result"}</button></div>
    </Modal>
  );
}

function OrdersPage({orders,setOrders,showToast}){
  const [search,setSearch]=useState("");
  const [prF,setPrF]=useState("All");
  const [stF,setStF]=useState("All");
  const [labF,setLabF]=useState("All");
  const [exp,setExp]=useState({1:true});
  const [modal,setModal]=useState(null);
  const close=()=>setModal(null);
  const toggle=id=>setExp(e=>({...e,[id]:!e[id]}));

  const allItems=orders.flatMap(o=>o.items);
  const stats={orders:orders.length,pending:allItems.filter(i=>i.status!=="Completed"&&i.status!=="Cancelled").length,completed:allItems.filter(i=>i.status==="Completed").length,stat:orders.filter(o=>o.priority==="STAT").length};

  const filtered=orders.filter(o=>{
    const pf=prF==="All"||o.priority===prF;
    const stf=stF==="All"||o.items.some(i=>i.status===stF);
    const lf=labF==="All"||o.lab_title===labF;
    const q=!search||o.patient_name.toLowerCase().includes(search.toLowerCase())||o.admission_no?.toLowerCase().includes(search.toLowerCase());
    return pf&&stf&&lf&&q;
  });

  const handleStatus=({status,sample_collected_at})=>{
    const {oid,iid}=modal.meta;
    setOrders(os=>os.map(o=>o.id!==oid?o:{...o,items:o.items.map(i=>i.id!==iid?i:{...i,status,sample_collected_at})}));
    showToast("Status updated");close();
  };
  const handleResult=({result_text,result_date})=>{
    const {oid,iid}=modal.meta;
    setOrders(os=>os.map(o=>o.id!==oid?o:{...o,items:o.items.map(i=>i.id!==iid?i:{...i,status:"Completed",result_text,result_date})}));
    showToast("Result saved");close();
  };
  const handleDelOrder=()=>{setOrders(os=>os.filter(o=>o.id!==modal.data.id));showToast("Order deleted");close();};
  const handleDelItem=()=>{const {oid,iid}=modal.meta;setOrders(os=>os.map(o=>o.id!==oid?o:{...o,items:o.items.filter(i=>i.id!==iid)}));showToast("Test removed");close();};

  return(<>
    <div className="sr" style={{gridTemplateColumns:"repeat(4,1fr)"}}>
      {[{l:"Total Orders",v:stats.orders,c:"var(--accent2)",b:"rgba(94,123,255,.3)"},{l:"Pending",v:stats.pending,c:"var(--amber)",b:"rgba(245,158,11,.3)"},{l:"Completed",v:stats.completed,c:"var(--green)",b:"rgba(16,185,129,.3)"},{l:"STAT",v:stats.stat,c:"var(--red)",b:"rgba(239,68,68,.3)"}].map(s=>(
        <div className="sc" key={s.l}><div className="sl">{s.l}</div><div className="sv" style={{color:s.c}}>{s.v}</div><div className="sb" style={{background:s.b}}/></div>
      ))}
    </div>
    <div className="fb">
      <div className="sw"><span className="si">🔍</span><input className="input sip" placeholder="Search patient or admission no…" value={search} onChange={e=>setSearch(e.target.value)}/></div>
      <select className="input sel" style={{width:120}} value={prF} onChange={e=>setPrF(e.target.value)}>{PRIORITIES.map(p=><option key={p}>{p}</option>)}</select>
      <select className="input sel" style={{width:150}} value={stF} onChange={e=>setStF(e.target.value)}>{STATUSES.map(s=><option key={s}>{s}</option>)}</select>
      <select className="input sel" style={{width:160}} value={labF} onChange={e=>setLabF(e.target.value)}><option>All</option>{LABS.map(l=><option key={l}>{l}</option>)}</select>
      <span style={{fontSize:11,color:"var(--muted)"}}>{filtered.length} order{filtered.length!==1?"s":""}</span>
    </div>
    {filtered.length===0?<div className="empty">No orders found</div>:filtered.map(order=>{
      const isOpen=exp[order.id];
      const total=order.items.reduce((s,i)=>s+i.amount,0);
      const pending=order.items.filter(i=>i.status!=="Completed"&&i.status!=="Cancelled").length;
      const pr=PRIORITY_STYLE[order.priority]||{};
      return(
        <div className="oc" key={order.id}>
          <div className="oh" onClick={()=>toggle(order.id)}>
            <div className="av" style={{background:pClr(order.patient_name)}}>{ini(order.patient_name)}</div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:600}}>{order.patient_name}<span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:10,color:"var(--muted)",marginLeft:8}}>{order.patient_phone}</span></div>
              <div style={{fontSize:11,color:"var(--muted)",marginTop:1}}>{order.ordered_by_name} · {order.order_date}{order.order_time?` ${order.order_time}`:""} · 🧪 {order.lab_title}{order.admission_no&&<span style={{color:"var(--accent2)",marginLeft:6}}>· {order.admission_no}</span>}{order.notes&&<span style={{fontStyle:"italic",marginLeft:6}}>{order.notes}</span>}</div>
            </div>
            <span className="chip" style={{background:pr.bg,color:pr.color,marginRight:4}}>{order.priority}</span>
            <span style={{fontSize:11,color:"var(--muted)",marginRight:8}}>{order.items.length} test{order.items.length!==1?"s":""}{pending>0&&<span style={{color:"var(--amber)",marginLeft:4}}>· {pending} pending</span>}</span>
            <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:14,fontWeight:600,color:"var(--accent2)"}}>₹{total.toLocaleString()}</span>
            <button className="ib d" style={{marginLeft:8}} onClick={e=>{e.stopPropagation();setModal({type:"delOrder",data:order});}}>🗑</button>
            <span style={{fontSize:12,color:"var(--muted)",marginLeft:6,display:"inline-block",transition:"transform .2s",transform:isOpen?"rotate(180deg)":"none"}}>▾</span>
          </div>
          {isOpen&&(
            <div style={{borderTop:"1px solid var(--border)"}}>
              {order.clinical_notes&&<div style={{padding:"9px 16px 9px 24px",fontSize:11,color:"var(--muted)",borderBottom:"1px solid var(--border)"}}>📌 {order.clinical_notes}</div>}
              {order.items.map(item=>{
                const sp=STATUS_STYLE[item.status]||{};
                return(
                  <div key={item.id} style={{padding:"11px 16px 11px 24px",borderBottom:"1px solid var(--border)",display:"flex",alignItems:"flex-start",gap:10}}>
                    <div style={{flex:1}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                        <span style={{fontSize:12,fontWeight:500}}>{item.test_title}</span>
                        <span style={{fontFamily:"'IBM Plex Mono',monospace",fontSize:11,color:"var(--accent2)",marginLeft:"auto"}}>₹{item.amount?.toLocaleString()}</span>
                      </div>
                      {item.sample_collected_at&&item.status!=="Completed"&&<div style={{fontSize:10,color:"var(--blue)",marginBottom:3}}>🧫 Collected: {item.sample_collected_at}</div>}
                      {item.result_text&&<div className="rb"><div style={{fontSize:9,color:"var(--dim)",textTransform:"uppercase",letterSpacing:".06em",marginBottom:3}}>{item.result_date}{item.sample_collected_at?` · sample ${item.sample_collected_at}`:""}</div>{item.result_text}</div>}
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:5,flexShrink:0,marginLeft:8}}>
                      <span className="sp" style={{background:sp.bg,color:sp.color}}><span style={{width:4,height:4,borderRadius:"50%",background:"currentColor",display:"inline-block"}}/>{item.status}</span>
                      <div style={{display:"flex",gap:4}}>
                        {item.status!=="Completed"&&item.status!=="Cancelled"&&<>
                          <button className="btn bg_ bsm" onClick={()=>setModal({type:"status",data:item,meta:{oid:order.id,iid:item.id}})}>Status</button>
                          <button className="btn bsm" style={{background:"rgba(16,185,129,.1)",color:"#10b981",border:"1px solid rgba(16,185,129,.3)"}} onClick={()=>setModal({type:"result",data:item,meta:{oid:order.id,iid:item.id}})}>+ Result</button>
                        </>}
                        <button className="ib d" onClick={()=>setModal({type:"delItem",data:item,meta:{oid:order.id,iid:item.id}})}>🗑</button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      );
    })}
    {modal?.type==="result"&&<ResultModal onClose={close} item={modal.data} onSave={handleResult}/>}
    {modal?.type==="status"&&<StatusModal onClose={close} item={modal.data} onSave={handleStatus}/>}
    {modal?.type==="delOrder"&&<DelModal onClose={close} onConfirm={handleDelOrder} title={`${modal.data.patient_name} · ${modal.data.order_date}`} msg="This will permanently delete the order and all its tests."/>}
    {modal?.type==="delItem"&&<DelModal onClose={close} onConfirm={handleDelItem} title={modal.data.test_title} msg="This will remove this test from the order."/>}
  </>);
}

function LinkModal({onClose,onSave}){
  const [f,setF]=useState({clinic_title:CLINICS[0],lab_title:LABS[0],is_default:1,notes:""});
  const [saving,setSaving]=useState(false);
  const set=(k,v)=>setF(p=>({...p,[k]:v}));
  const save=()=>{
    setSaving(true);
    const info=LAB_INFO[f.lab_title]||{};
    setTimeout(()=>onSave({clinic_title:f.clinic_title,lab_title:f.lab_title,lab_phone:info.phone||null,lab_email:info.email||null,is_default:f.is_default,active:1,notes:f.notes.trim()||null}),500);
  };
  return(
    <Modal title="Add Lab Link" onClose={onClose}>
      <div className="mg">
        <div className="field mf"><label>Clinic *</label><select className="input sel" value={f.clinic_title} onChange={e=>set("clinic_title",e.target.value)}>{CLINICS.map(c=><option key={c}>{c}</option>)}</select></div>
        <div className="field mf"><label>Lab (Pathologist) *</label><select className="input sel" value={f.lab_title} onChange={e=>set("lab_title",e.target.value)}>{LABS.map(l=><option key={l}>{l}</option>)}</select></div>
        <div className="field"><label>Default Lab</label><div className="tw" style={{marginTop:6}}><div className={`tgl ${f.is_default?"on":""}`} onClick={()=>set("is_default",f.is_default?0:1)}><div className="tk"/></div><span style={{fontSize:12}}>{f.is_default?"Default":"Secondary"}</span></div></div>
        <div className="field mf"><label>Notes</label><textarea className="input ta" value={f.notes} onChange={e=>set("notes",e.target.value)} placeholder="Notes about this link…" style={{minHeight:56}}/></div>
      </div>
      <div className="ma"><button className="btn bg_" onClick={onClose}>Cancel</button><button className="btn bp" onClick={save} disabled={saving}>{saving?"Saving…":"Add Link"}</button></div>
    </Modal>
  );
}

function LinksPage({links,setLinks,showToast}){
  const [search,setSearch]=useState("");
  const [clF,setClF]=useState("All");
  const [actF,setActF]=useState("All");
  const [modal,setModal]=useState(null);
  const close=()=>setModal(null);

  const stats={total:links.length,active:links.filter(l=>l.active).length};

  const filtered=links.filter(l=>{
    const cf=clF==="All"||l.clinic_title===clF;
    const af=actF==="All"||(actF==="1"?l.active===1:l.active===0);
    const q=!search||l.clinic_title.toLowerCase().includes(search.toLowerCase())||l.lab_title.toLowerCase().includes(search.toLowerCase());
    return cf&&af&&q;
  });

  const handleDel=()=>{setLinks(ls=>ls.filter(l=>l.id!==modal.data.id));showToast("Link deleted");close();};
  const toggleActive=id=>setLinks(ls=>ls.map(l=>l.id===id?{...l,active:l.active?0:1}:l));

  return(<>
    <div className="sr" style={{gridTemplateColumns:"repeat(2,1fr)"}}>
      {[{l:"Total Links",v:stats.total,c:"var(--accent2)",b:"rgba(94,123,255,.3)"},{l:"Active Links",v:stats.active,c:"var(--green)",b:"rgba(16,185,129,.3)"}].map(s=>(
        <div className="sc" key={s.l}><div className="sl">{s.l}</div><div className="sv" style={{color:s.c}}>{s.v}</div><div className="sb" style={{background:s.b}}/></div>
      ))}
    </div>
    <div className="fb">
      <div className="sw"><span className="si">🔍</span><input className="input sip" placeholder="Search clinic or lab name…" value={search} onChange={e=>setSearch(e.target.value)}/></div>
      <select className="input sel" style={{width:200}} value={clF} onChange={e=>setClF(e.target.value)}><option>All</option>{CLINICS.map(c=><option key={c}>{c}</option>)}</select>
      <select className="input sel" style={{width:120}} value={actF} onChange={e=>setActF(e.target.value)}><option value="All">All Status</option><option value="1">Active</option><option value="0">Inactive</option></select>
      <span style={{fontSize:11,color:"var(--muted)"}}>{filtered.length} link{filtered.length!==1?"s":""}</span>
    </div>
    {filtered.length===0?<div className="empty">No linked labs found</div>:filtered.map(link=>(
      <div key={link.id} className={`lc${!link.active?" off":""}`}>
        <div className="av" style={{background:pClr(link.lab_title),borderRadius:10,width:38,height:38,fontSize:13}}>{ini(link.lab_title)}</div>
        <div style={{flex:1}}>
          <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
            <span style={{fontSize:13,fontWeight:600}}>{link.lab_title}</span>
            <span className="chip" style={link.is_default?{background:"rgba(94,123,255,.12)",color:"var(--accent2)"}:{background:"var(--bg3)",color:"var(--muted)"}}>{link.is_default?"● Default":"Secondary"}</span>
          </div>
          <div style={{fontSize:11,color:"var(--muted)",marginTop:3}}>🏥 {link.clinic_title}</div>
          <div style={{fontSize:11,color:"var(--muted)",marginTop:2,fontFamily:"'IBM Plex Mono',monospace"}}>{link.lab_phone} · {link.lab_email}</div>
          {link.notes&&<div style={{fontSize:11,color:"var(--muted)",marginTop:3,fontStyle:"italic"}}>{link.notes}</div>}
        </div>
        <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:6,flexShrink:0}}>
          <span className="chip" onClick={()=>toggleActive(link.id)} style={{cursor:"pointer",background:link.active?"rgba(16,185,129,.1)":"rgba(239,68,68,.1)",color:link.active?"#10b981":"#ef4444"}}>{link.active?"Active":"Inactive"}</span>
          <button className="ib d" onClick={()=>setModal({type:"del",data:link})}>🗑</button>
        </div>
      </div>
    ))}
    {modal?.type==="del"&&<DelModal onClose={close} onConfirm={handleDel} title={`${modal.data.lab_title} · ${modal.data.clinic_title}`} msg="This will remove the lab link from the clinic."/>}
  </>);
}

export default function LabOrdersManagement(){
  const [tab,setTab]=useState("orders");
  const [orders,setOrders]=useState(INIT_ORDERS);
  const [links,setLinks]=useState(INIT_LINKED_LABS);
  const [toast,setToast]=useState(null);
  const [addOrder,setAddOrder]=useState(false);
  const [addLink,setAddLink]=useState(false);

  const showToast=msg=>{setToast(msg);setTimeout(()=>setToast(null),2500);};

  return(<>
    <style>{css}</style>
    <div className="page">
      <div className="ph">
        <div><div className="ph-title">🧪 Lab Orders Management</div><div className="ph-sub">Manage patient lab orders and linked labs</div></div>
        {tab==="orders"&&<button className="btn bp" onClick={()=>setAddOrder(true)}>+ Add Order</button>}
        {tab==="links"&&<button className="btn bp" onClick={()=>setAddLink(true)}>+ Add Lab Link</button>}
      </div>
      <div className="page-tabs">
        <button className={`ptab ${tab==="orders"?"active":""}`} onClick={()=>setTab("orders")}>📋 Lab Orders ({orders.length})</button>
        <button className={`ptab ${tab==="links"?"active":""}`} onClick={()=>setTab("links")}>🔗 Linked Labs ({links.length})</button>
      </div>
      {tab==="orders"&&<OrdersPage orders={orders} setOrders={setOrders} showToast={showToast}/>}
      {tab==="links"&&<LinksPage links={links} setLinks={setLinks} showToast={showToast}/>}
    </div>
    {addOrder&&<OrderModal onClose={()=>setAddOrder(false)} onSave={form=>{setOrders(os=>[{...form,id:Date.now(),ordered_by_name:"Dr. Priya Mehta"},...os]);showToast("Order added");setAddOrder(false);}}/>}
    {addLink&&<LinkModal onClose={()=>setAddLink(false)} onSave={form=>{setLinks(ls=>[{...form,id:Date.now()},...ls]);showToast("Lab link added");setAddLink(false);}}/>}
    {toast&&<div className="toast"><span style={{color:"var(--green)",fontSize:16}}>✓</span>{toast}</div>}
  </>);
}
